<div class="container pt-5">
  <h2 *ngIf="isLoading()" class="text-center my-2" [translate]="'pages.entry.wait'">Loading, please wait...</h2>
  <h3 *ngIf="isError()" class="text-danger text-center" [translate]="'pages.entry.error'">Something went wrong. Please check the internet connection.</h3>
</div>
